module.exports = __webpack_public_path__ + "public/images/slider/speaker-5-icon.bfc476a401072879a8fb330726186127.png";